const WHATSAPP_NUMBER = "919164866699";

const FIELD_LABELS = {
  name: "Full Name",
  email: "Email",
  phone: "Phone",
  city: "City",
  eventType: "Event Type",
  message: "Message",
  consent: "Consent",
  resume: "Resume"
};

const formatLabel = (key) => {
  if (FIELD_LABELS[key]) {
    return FIELD_LABELS[key];
  }

  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
    .trim();
};

const normalizeValue = (value, key) => {
  if (value instanceof File) {
    return value.name ? value.name : "";
  }

  if (key === "consent") {
    return value ? "Yes" : "No";
  }

  return String(value).trim();
};

export const sendWhatsAppForm = ({ event, heading, footerLines }) => {
  event.preventDefault();

  const form = event.currentTarget;
  const data = new FormData(form);
  const lines = [];

  if (heading) {
    lines.push(heading);
  }

  for (const [key, value] of data.entries()) {
    const normalizedValue = normalizeValue(value, key);
    if (!normalizedValue) {
      continue;
    }
    lines.push(`- ${formatLabel(key)}: ${normalizedValue}`);
  }

  if (Array.isArray(footerLines) && footerLines.length) {
    lines.push("");
    footerLines.filter(Boolean).forEach((line) => lines.push(String(line).trim()));
  }

  if (!lines.length) {
    return;
  }

  const message = lines.join("\n");
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  const opened = window.open(url, "_blank", "noopener,noreferrer");

  if (!opened) {
    window.location.href = url;
  }
};
